import React from 'react';
import { SearchByEan } from './SearchByEan';
import { SearchProductFilter } from './SearchProductFilter';
import { SearchSort } from './SearchSort';
import { SearchPointLimit } from './SearchPointLimit';
import { Config } from '../../../config';

export const ArticleFilter: React.FC = () => (
    <>
        {Config.get().isPhysicalBookstore && (
            <div className="row">
                <div className="col-sm-8">
                    <SearchByEan />
                </div>
            </div>
        )}
        <div className="row filter-actions">
            <div className="col-sm-4">{Config.get().customerData.pseudoCustomer || <SearchProductFilter />}</div>
            <div className="col-sm-4">
                <SearchSort />
            </div>
            <div className="col-sm-4">
                <SearchPointLimit />
            </div>
        </div>
    </>
);
